import cntl from 'cntl'
import Accordion from 'components/Accordion'
import Link from 'components/Link'
import Logo from 'components/Logo'
import React from 'react'
import { IProps, LinkListItem } from './LinkList'
import { prepareData } from 'utils/googleData'
import { GitHub, LinkedIn, YouTube, SlackMonochrome, Twitter, Facebook } from 'components/Icons/Icons'
import { useStaticQuery, graphql } from 'gatsby'

const linkList: IProps[] = [
    {
        title: 'Products',
        url: '/products/property-management',
        items: [
            {
                title: 'Property management',
                url: '/property-management',
            },
            {
                title: 'Real estate crm',
                url: '/real-estate-crm',
            },
            {
                title: 'Real estate marketing',
                url: '/real-estate-marketing',
            },
            {
                title: 'Mobile apps',
                url: '/real-estate-mobile-apps',
            },
            {
                title: 'Transaction management',
                url: '/transaction-management',
            },
            {
                title: 'Websites',
                url: '/real-estate-websites',
            },
            {
                title: 'listings hub',
                url: '/listings-hub',
            },
            {
                title: 'Analytics',
                url: '/docs/analytics',
            },
            {
                title: 'Real estate platform',
                url: '/real-estate-platform',
            },
        ],
    },
    {
        title: 'Markets',
        url: '/markets',
        items: [
            {
                title: 'Commercial',
                url: '/markets/commercial',
            },
            {
                title: 'Residential',
                url: '/markets/residential',
            },
            // {
            //     title: 'Industrial',
            //     url: '/markets/industrial',
            // },
            // {
            //     title: 'Affordable',
            //     url: '/markets/affordable',
            // },
            // {
            //     title: 'Investment',
            //     url: '/markets/investment',
            // },
            {
                title: 'Student',
                url: '/markets/student',
            },
            // {
            //     title: 'Coworking',
            //     url: '/markets/coworking',
            // },
            // {
            //     title: 'Military',
            //     url: '/markets/military',
            // },
            // {
            //     title: 'Senior',
            //     url: '/markets/senior',
            // },
        ],
    },
    // {
    //     title: 'Docs',
    //     url: '/docs',
    //     items: [
    //         {
    //             title: 'Start here',
    //             url: '/start-icloudready',
    //         },
    //         {
    //             title: 'Property management',
    //             url: '/docs/property-management/',
    //         },
    //         {
    //             title: 'Real estate crm',
    //             url: '/docs/real-estate-crm',
    //         },
    //         {
    //             title: 'Real estate marketing',
    //             url: '/docs/real-estate-marketing',
    //         },
    //         {
    //             title: 'Websites',
    //             url: '/docs/websites',
    //         },
    //         {
    //             title: 'Mobile Apps',
    //             url: '/docs/real-estate-mobile-apps',
    //         },
    //         {
    //             title: 'Transaction management',
    //             url: '/docs/transaction-management',
    //         },
    //         {
    //             title: 'Listings hub',
    //             url: '/docs/listings-hub',
    //         },
    //         {
    //             title: 'Analytics',
    //             url: '/docs/analytics',
    //         },
    //         {
    //             title: 'Platform',
    //             url: '/docs/integrations',
    //         },
    //         {
    //             title: 'API',
    //             url: '/docs/api/units',
    //         },
    //     ],
    // },
    // {
    //     title: 'Support',
    //     url: '/questions',
    //     items: [
    //         {
    //             title: 'Questions?',
    //             url: '/questions',
    //         },
    //         {
    //             title: 'Product roadmap',
    //             url: '/roadmap',
    //         },
    //         {
    //             title: 'Marketplace',
    //             url: '/marketplace',
    //         },
    //         {
    //             title: 'Newsletter',
    //             url: '/newsletter',
    //         },
    //         {
    //             title: 'Pricing',
    //             url: '/pricing',
    //         },
    //         {
    //             title: 'iCloudReady vs...',
    //             url: '/blog/tags/comparisons',
    //         },
    //         {
    //             title: 'Tutorials',
    //             url: '/tutorials',
    //         },
    //         {
    //             title: 'Academy',
    //             url: '/academy',
    //         },
    //         {
    //             title: 'Book a demo',
    //             url: '/book-a-meeting',
    //         },
    //     ],
    // },
    {
        title: 'Use Cases',
        url: '/markets',
        items: [
            // {
            //     title: 'Agents',
            //     url: '/markets/agents',
            // },
            {
                title: 'Brokers',
                url: '/brokers',
            },
            {
                title: 'Enterprises',
                url: '/markets/enterprises',
            },
            {
                title: 'Teams',
                url: '/markets/teams',
            },
            // {
            //     title: 'Startups',
            //     url: '/startups',
            // },
            // {
            //     title: 'Customer stories',
            //     url: '/customers',
            // },
        ],
    },
    // {
    //     title: 'How We Work',
    //     url: '/how-we-work',
    //     items: [
    //         {
    //             title: 'Getting started',
    //             url: '/how-we-work/getting-started/start-here',
    //         },
    //         {
    //             title: 'Company',
    //             url: '/how-we-work/company/story',
    //         },
    //         {
    //             title: 'Strategy',
    //             url: '/how-we-work/strategy/overview',
    //         },
    //         {
    //             title: 'How we work',
    //             url: '/how-we-work/company/culture',
    //         },
    //         {
    //             title: 'Our teams',
    //             url: '/our-teams/team-structure',
    //         },
    //         {
    //             title: 'People & Ops',
    //             url: '/how-we-work/people/compensation',
    //         },
    //         {
    //             title: 'Engineering',
    //             url: '/how-we-work/engineering/developing-locally',
    //         },
    //         {
    //             title: 'Product',
    //             url: '/how-we-work/product/product-team',
    //         },
    //         {
    //             title: 'Design',
    //             url: '/how-we-work/design/philosophy',
    //         },
    //         {
    //             title: 'Marketing',
    //             url: '/how-we-work/growth/marketing',
    //         },
    //         {
    //             title: 'Customer success',
    //             url: '/how-we-work/growth/strategy',
    //         },
    //     ],
    // },
    {
        title: 'Company',
        url: '/about-us',
        items: [
            {
                title: 'About Us',
                url: '/about-us',
            },
            // {
            //     title: 'Team',
            //     url: '/team',
            // },
            // {
            //     title: 'Investors',
            //     url: '/how-we-work/strategy/investors',
            // },
            // {
            //     title: 'Press',
            //     url: '/media',
            // },
            {
                title: 'Blog',
                url: '/blog',
            },
            {
                title: 'FAQ',
                url: '/faq',
            },
            {
                title: 'Careers',
                url: '/careers',
            },
            // {
            //     title: 'Events',
            //     url: '/webinars-events',
            // },
            // {
            //     title: 'How We Work',
            //     url: '/how-we-work',
            // },
            {
                title: 'Contact us',
                url: '/book-a-meeting',
            },
        ],
    },
]

const linksHeadingSm = cntl`
    text-base
    text-gray
    dark:text-gray
    mb-1
    leading-tight
    pb-[0.2rem]
`
const linksHeadingMd = cntl`
    text-lg
    mb-5
    leading-tight
`

const linksHeadingLg = cntl`
    text-xl flex
    justify-between
    items-center
    leading-tight
    mb-5
`

const link = (marginBottom = '1') => cntl`
    leading-tight
    text-primary
    hover:text-primary
    dark:text-primary-dark
    dark:hover:text-white
    text-base
    font-bold
    mb-${marginBottom}
    inline-block
`

const FooterMenuItem = ({ title, url, className = '', marginBottom = '1' }) => {
    return (
        <li className={className}>
            <Link className={link(marginBottom)} to={url}>
                {title}
            </Link>
        </li>
    )
}

const tosPrivacyLinks = [
    // {
    //     title: 'System status',
    //     url: 'https://status.icloud-ready.com',
    // },
    {
        title: 'Privacy policy',
        url: '/privacy',
    },
    {
        title: 'Terms',
        url: '/terms',
    },
]

const company = 'iCoudReady, Inc.'
const social = [
    // {
    //     Icon: <SlackMonochrome className="box-border h-8 w-8 fill-current" />,
    //     url: '/slack',
    // },
    // {
    //     Icon: <Twitter className="box-border h-8 w-8 fill-current" />,
    //     url: 'https://twitter.com/icloud-ready',
    // },
    {
        Icon: LinkedIn,
        style: 'box-border h-8 w-8',
        url: 'https://www.linkedin.com/company/icloud-ready',
    },
    // {
    //     Icon: (
    //         <span className="fill-current">
    //             <YouTube className="box-border h-8 w-8" />
    //         </span>
    //     ),
    //     url: 'https://www.youtube.com/channel/UCpSCr19KznqKIbMXFtnH3-Q',
    // },
    // {
    //     Icon: (
    //         <span className="fill-current">
    //             <GitHub className="box-border h-8 w-8" />
    //         </span>
    //     ),
    //     url: 'https://github.com/icloud-ready',
    // },
    {
        Icon: Facebook,
        style: 'box-border h-8 w-8',
        url: 'https://facebook.com/icloud-ready',
    },
]
export function Footer(prop): JSX.Element {
    const { footer } = useStaticQuery(query)
    const result = prepareData({
        props: footer.nodes[0].parent,
    })
    const { enable, direction, linkList, tosPrivacyList, name, Icon } = result
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const style = result.style || 'grid-cols-2 md:grid-cols-2 lg:grid-cols-4'
    const socialList = result.socialList
    return (
        <footer
            dir={direction}
            className="border-t border-dashed border-gray-accent-light dark:border-gray-accent-dark"
        >
            <div dir={direction} className="relative -top-6">
                <Link
                    to="/"
                    // className="left-[calc(50%-40px)] w-20 h-12 inline-flex justify-center items-center absolute z-10 rounded bg-light dark:bg-dark px-2 pt-1.5 pb-1 mb-1 border border-b-3 border-light dark:border-dark hover:bg-accent dark:hover:bg-accent-dark hover:translate-y-[-1px] active:translate-y-[1px] active:transition-all"
                    className="dark:!hover:gray-accent-dark absolute left-[calc(50%-40px)] z-10 inline-flex h-12 w-20 items-center justify-center rounded border border-dashed border-gray-accent-light !bg-tan px-4 transition-all hover:scale-[1.02] hover:!bg-gray-accent-light/90 active:top-[1px] active:scale-[.99] active:!bg-gray-accent-light/100  dark:border-dark  dark:!bg-dark"
                >
                    <span className="inline-block">{Icon && <Icon />}</span>
                </Link>
            </div>

            <div
                dir={direction}
                className={`mx-auto grid w-full max-w-screen-2xl  border-r border-dashed border-gray-accent-light last:border-r-0 dark:border-gray-accent-dark lg:border-r-0 ${style}`}
            >
                {linkList?.length > 0 && linkList.map((item, index) => <LinkListItem {...item} key={index} />)}
            </div>

            <div
                dir={direction}
                className="flex justify-center border-dashed border-gray-accent-light dark:border-gray-accent-dark lg:border-t"
            >
                <ul className="flex list-none space-x-4 px-0 py-2">
                    {socialList?.length > 0 &&
                        socialList.map(({ Icon, url, enable, style = '' }: Social, index) => {
                            if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
                                return <></>
                            }
                            return (
                                <li key={index}>
                                    <Link
                                        to={url}
                                        className="relative inline-flex rounded p-2 opacity-70 transition-all hover:scale-[1.01] hover:bg-gray-accent-light hover:opacity-90 active:top-[1px] active:scale-[.99] dark:hover:bg-gray-accent-dark"
                                    >
                                        {Icon && (
                                            <span className="fill-current">
                                                <Icon className={`box-border h-8 w-8 ${style}`} />
                                            </span>
                                        )}
                                    </Link>
                                </li>
                            )
                        })}
                </ul>
            </div>
            <div
                dir={direction}
                className="border-t border-l-0 border-r-0 border-dashed border-gray-accent-light py-5 dark:border-gray-accent-dark"
            >
                <div dir={direction} className="mx-auto flex max-w-7xl flex-col items-center px-5 text-lg sm:flex-row">
                    <small dir={direction} className="font-semibold dark:text-gray">
                        &copy; {new Date().getFullYear()} {name}
                    </small>
                    <ul
                        dir={direction}
                        className="m-0 mt-2 flex list-none space-x-4 p-0 sm:ml-auto sm:mt-0 sm:space-x-8"
                    >
                        {tosPrivacyList?.length > 0 &&
                            tosPrivacyList.map(({ title, url, enable }, index) => {
                                if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
                                    return <></>
                                }
                                return (
                                    <li dir={direction} key={index}>
                                        <Link
                                            to={url}
                                            className="dark text-sm font-bold text-almost-black/70 hover:text-almost-black/90 dark:text-gray dark:hover:text-gray"
                                        >
                                            {title}
                                        </Link>
                                    </li>
                                )
                            })}
                    </ul>
                </div>
            </div>
        </footer>
    )
}

const query = graphql`
    query Footer {
        footer: allMdx(filter: { fields: { slug: { eq: "/" } }, frontmatter: { title: { ne: "" } } }) {
            nodes {
                id
                parent {
                    ... on GoogleDocs {
                        id
                        allFooter: homeFooter {
                            linkList {
                                url
                                enable
                                title
                                title_ar
                                items {
                                    url
                                    title
                                    title_ar
                                    enable
                                }
                            }
                            style
                            icon
                            name
                            enable
                            name_ar
                            socialList {
                                url
                                icon
                                enable
                            }
                            tosPrivacyList {
                                url
                                title
                                title_ar
                                enable
                            }
                        }
                    }
                }
            }
        }
    }
`
